export const FACTION_HUMANS_POLICY_DISCOUNT = 3;